import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import Button from "./ToolbarButton";
import { ToolbarWrap, Separator } from "./ToolbarUtils";
import { useEditorContext } from "./EditorContext";

interface EmojiToolbarProps {
  emojis: string[];
  onInsertEmoji: (emoji: string) => void;
  onBack: () => void;
}

export default function EmojiToolbar({
  emojis,
  onInsertEmoji,
  onBack,
}: EmojiToolbarProps) {
  const { readOnly } = useEditorContext();
  return (
    <ToolbarWrap>
      <Button
        onClick={onBack}
        tooltip={I18n.t("js.composer.editor.buttons.back_to_toolbar")}
        disabled={readOnly}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </Button>

      <Separator />

      {emojis.map((emoji) => (
        <Button
          key={emoji}
          onClick={() => onInsertEmoji(emoji)}
          tooltip={I18n.t("js.composer.editor.buttons.emoji.insert", {
            emoji: emoji,
          })}
          disabled={readOnly}
        >
          {emoji}
        </Button>
      ))}
    </ToolbarWrap>
  );
}
